const object = {
  id: '61l33svv2hmrqab1og0ac667x',
  type: 'image',
  layout: {
    top: 0,
    left: 0,
    width: '100%',
    height: 222,
    zIndex: 1,
    position: 'absolute',
    marginTop: 0,
    marginLeft: 0,
    right: 0,
  },
  mobile: {
    layout: {
      top: 58,
    },
    attributes: {
      adjustedY: 58,
    },
  },
  tablet: {
    layout: {
      top: 58,
    },
    attributes: {
      adjustedY: 58,
    },
  },
  desktop: {
    layout: {
      top: 58,
    },
    attributes: {
      adjustedY: 58,
    },
  },
  children: [],
  pushGraph: {
    edges: [],
    nodeIds: [],
  },
  attributes: {
    x: 59.00000000000003,
    y: 58,
    name: 'Image 3',
    width: 773.9999999999998,
    height: 222,
    hidden: false,
    zIndex: 1,
    opacity: 1,
    adjustedY: 58,
    imageType: 'uploaded',
    pushGraph: {
      edges: [],
      nodeIds: [],
    },
    filename1x: {
      url: 'b910c26f9b9b1f3b2c36dcfdc41cd15952c27f74e40a1f53b600c410490e32dc.jpg',
      filename: 'usgs-hoS3dzgpHzw-unsplash.jpg',
      metadata: {
        width: 7146,
        height: 7162,
        urlHash: 'b2188968c208ceced4a438328096874056233e81',
        blurHash: 'eUCrvg^k%2xas:{}#-ofsooL+aaeNGWAWB-qtRWUj]bHv}WBX9f+f+',
        blurHashWidth: 32,
      },
    },
    borderColor: '#999',
    borderStyle: 'none',
    borderWidth: 1,
    imageResize: 'contain',
    positioning: 'fixedTop',
    borderRadius: 70,
    imageBinding: null,
    initialDevice: 'desktop',
    backgroundColor: '#ddd',
    backgroundStyle: 'none',
  },
  positioning: 'fixedTop',
  responsivity: {
    verticalScaling: 'FIXED',
    horizontalScaling: 'SCALES_WITH_PARENT',
    verticalPositioning: 'TOP',
    horizontalPositioning: 'CENTER',
  },
}

export default object
